import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/signin`);

class SignInSmsVerification {
  constructor(data) {
    const { expireDate } = data;
    this.expireDate = expireDate;
  }
}

export const signInSmsVerificationMapper = (item) => {
  return new SignInSmsVerification({
    expireDate: objectSelector(item, $P.SIGN_IN_SMS_CODE_EXPIRE_DATE),
  });
};



// WEBPACK FOOTER //
// ./src/models/signInSmsVerification.js